import { useSelector } from "react-redux"
import "../PlayList.scss"

export const DataPLaylist = () =>{
    const { AllPlayListsData} = useSelector((state:any) => ({ ...state.playlist }))
    const columns :any= [
    ];
    const data = {
        totalElements: AllPlayListsData?.totalCount,
        content:
        (typeof AllPlayListsData === 'undefined') ?  [] :  AllPlayListsData?.edges
      };
    
    return({
        columns,
        data
    })

}